import PropTypes from 'prop-types'
import React from 'react'

import { RU, UK } from 'constants/countries'
import { GOODS_TYPES } from 'constants/sales'
import { LocalizationContext } from 'contexts/Localization'
import { Row, Col } from 'styles/components/layout'

import CartEmptyItemNew from './components/CartEmptyItemNew'
import { BoxBaseStyled } from './styles'

const CartEmptyNew = ({ cart, texts, isCartInitOrUpdate, increaseGoods }) => {
  const { dict, paths, currentCountry, sales, locale } = React.useContext(
    LocalizationContext,
  )
  const { isOrderCollected } = cart
  const isDisabled = isCartInitOrUpdate || isOrderCollected

  const testsOrder = React.useMemo(() => {
    if (locale === UK) {
      return [GOODS_TYPES.biome, GOODS_TYPES.dna]
    } else if (locale === RU) {
      return [GOODS_TYPES.dna, GOODS_TYPES.biome, GOODS_TYPES.wgs]
    }

    return [GOODS_TYPES.dna, GOODS_TYPES.biome]
  }, [locale])

  const goods = React.useMemo(
    () =>
      sales.goods ? testsOrder.filter(good => sales.goods[good].isActive) : [],
    [sales, testsOrder],
  )

  return (
    <BoxBaseStyled>
      <Row>
        <Col width={{ xs: 1 }}>
          {goods.map(productType => (
            <CartEmptyItemNew
              key={productType}
              dict={dict}
              texts={texts}
              boxes={`${paths.cdn_global}/boxes/${productType}-${
                locale === RU ? 'left-new' : 'cart-new'
              }`}
              productType={productType}
              productInfo={sales.goods[GOODS_TYPES[productType]]}
              productConfig={sales.goods[GOODS_TYPES[productType]]}
              discount={sales.goods[GOODS_TYPES[productType]].discount}
              currencyCode={sales.currency}
              precision={sales.precision}
              handleIncrease={increaseGoods}
              intlCode={currentCountry.intlCode}
              isDisabled={isDisabled}
              isCartInitOrUpdate={isCartInitOrUpdate}
            />
          ))}
        </Col>
      </Row>
    </BoxBaseStyled>
  )
}

CartEmptyNew.propTypes = {
  /** State of cart */
  cart: PropTypes.object.isRequired,

  /** Object with localized texts for cart page */
  texts: PropTypes.object.isRequired,

  /** Hide price when cart init or update  */
  isCartInitOrUpdate: PropTypes.bool,

  /** Increase amount of current goods in the cart */
  increaseGoods: PropTypes.func.isRequired,
}

export default React.memo(CartEmptyNew)
